import {
  AnalyticsEventPropTypes,
  ACTIONS,
  activity,
  eventDetailVersion
} from '@uma/react-commons/dist/index';
import { screenDetailsPath, screenDetailsName } from 'src/utils/analytics';

export const SecurityDetailsScreenDisplayed: AnalyticsEventPropTypes = {
  action: ACTIONS.SCREEN_DISPLAYED,
  activity,
  screenPath: screenDetailsPath,
  screenName: screenDetailsName,
  version: eventDetailVersion
};
